import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CerEmojiService {
  constructor() {}

  // Transform a text, like "Hi :thumbsup:", to "Hi <img>"
  public transform(text: string): string {
    return text;
  }
}